import React from "react"
import { Helmet } from "react-helmet"

const SITE_URL = "https://gadait-international.com"

const toAbsoluteUrl = path => `${SITE_URL}${path}`

const StaticAlternates = ({
  locale,
  canonicalPath,
  enPath,
  frPath,
  xDefaultPath,
}) => {
  const canonical = toAbsoluteUrl(canonicalPath)
  const enHref = toAbsoluteUrl(enPath)
  const frHref = toAbsoluteUrl(frPath)
  const xDefaultHref = toAbsoluteUrl(xDefaultPath || enPath)

  return (
    <Helmet>
      {locale ? <html lang={locale} /> : null}
      <link rel="canonical" href={canonical} />
      <link rel="alternate" hreflang="en" href={enHref} />
      <link rel="alternate" hreflang="fr" href={frHref} />
      <link rel="alternate" hreflang="x-default" href={xDefaultHref} />
    </Helmet>
  )
}

export default StaticAlternates
